// routes for WorkSchedulePrint
import { AppRouteProps } from '~/routes';
import Index from './pages/Index';
import Create from './pages/Create';
import Edit from './pages/Edit';

export default function ResourcesMaterialGroupRoutes(): readonly AppRouteProps[] {
  const routes: readonly AppRouteProps[] = [
    {
      path: '/material-group',
      component: Index,
      isProtected: true,
      permissions: ['material_group_index'],
    },
    {
      path: '/material-group/create',
      component: Create,
      isProtected: true,
      permissions: ['material_group_create'],
    },
    {
      path: '/material-group/edit/:id',
      component: Edit,
      isProtected: true,
      permissions: ['material_group_edit'],
    },
  ];

  return routes;
}